import dayjs from "@eisox/dayjs";

function assertValidMonth(month: number): void {
  if (!Number.isInteger(month) || month < 0 || month > 11) {
    throw new RangeError("month must be an integer between 0 and 11");
  }
}

/** Premier instant du mois calendaire (UTC). */
export function monthRangeStart(year: number, month: number): Date {
  assertValidMonth(month);
  return dayjs.utc().year(year).month(month).date(1).startOf("day").toDate();
}

/** Dernier instant du mois calendaire (UTC). */
export function monthRangeEnd(year: number, month: number): Date {
  assertValidMonth(month);
  return dayjs.utc().year(year).month(month).date(1).endOf("month").toDate();
}

/** Extrait année/mois calendaires depuis une Date (UTC), pour selectedMonthRange. */
export function monthFromDate(date: Date): { year: number; month: number } {
  const d = dayjs.utc(date);
  return { year: d.year(), month: d.month() };
}
